import { Fragment } from "react/jsx-runtime";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";

type HandlePopupCloseType = (confirmLeave: boolean) => void;

interface OrderDiscardPopupProps {
  handlePopupClose: HandlePopupCloseType;
}

export default function OrderDiscardPopup({
  handlePopupClose,
}: OrderDiscardPopupProps) {
  return (
    <Fragment>
      <CustomText
        text="Are you sure you want to exit? all the changes will be discarded"
        fontWeight="font-normal"
        className="text-red-500"
      />
      <div className="flex items-end  justify-end mt-3">
        <Button
          textInformation={{ text: "Cancel", fontWeight: "font-semibold" }}
          onClick={() => handlePopupClose(false)}
          buttonTheme="secondary"
          className="mr-3"
        />
        <Button
          textInformation={{ text: "Yes", fontWeight: "font-semibold" }}
          onClick={() => handlePopupClose(true)}
          buttonTheme="primary"
        />
      </div>
    </Fragment>
  );
}
